export default __webpack_public_path__ + "static/media/15.84804ab6.svg";